import type { ReactNode } from "react";
import { Form } from "antd";
import type { FormInstance } from "antd";
import type {
  ZuuFinancialAnalysisSectionProps,
  ZuuOnlyProvideOneProductSectionProps,
  ZuuProductSelectionSectionProps,
  ZuuPremiumFinancingSectionProps,
  ZuuSuggestionsSectionProps,
} from "./ZuuFnaForm";

type GenericFnaFormProps = {
  form: FormInstance;
  readOnly?: boolean;
  className?: string;
  children?: ReactNode;
  zuuFinancialAnalysisProps?: ZuuFinancialAnalysisSectionProps;
  zuuPremiumFinancingProps?: ZuuPremiumFinancingSectionProps;
  zuuProductSelectionProps?: ZuuProductSelectionSectionProps;
  zuuOnlyProvideOneProductProps?: ZuuOnlyProvideOneProductSectionProps;
  zuuSuggestionsProps?: ZuuSuggestionsSectionProps;
};

export function GenericFnaForm({
  form,
  readOnly = false,
  className,
  children,
  zuuFinancialAnalysisProps: _zuuFinancialAnalysisProps,
  zuuPremiumFinancingProps: _zuuPremiumFinancingProps,
  zuuProductSelectionProps: _zuuProductSelectionProps,
  zuuOnlyProvideOneProductProps: _zuuOnlyProvideOneProductProps,
  zuuSuggestionsProps: _zuuSuggestionsProps,
}: GenericFnaFormProps) {
  return (
    <Form
      form={form}
      layout="vertical"
      disabled={readOnly}
      className={className}
    >
      {children}
    </Form>
  );
}
